export const ModuleAuth = "auth";
// export const ModuleCommon = 'common';
// export const ModuleCompany = 'company';
export const ModuleContext = "context";
// export const ModuleContactAdditional = 'contactadditional';
export const ModuleDashboard = "dashboard";
// export const ModuleDictionary = 'dictionary';
// export const ModuleLayout = 'layout';
// export const ModuleLicenseInfo = 'licenseinfo';
// export const ModuleAccessLog = 'accesslog';
// export const ModuleMisaOrder = 'misaorder';
export const ModuleNotifications = "notifications";
// export const ModuleOptions = 'options';
// export const ModuleServiceTVAN = 'servicetvan';
// export const ModuleTaxRegis = 'taxregis';
// export const ModuleTaxReturnRegisHistory = 'taxreturnregishistory';
// export const ModuleTaxReturn = 'taxreturn';
// export const ModuleTaxReturnSubmission = 'taxreturnsubmission';
// export const ModuleTaxPaper = 'taxpaper';
// export const ModuleTaxPayerInfo = 'taxpayerinfo';P
export const ModuleAsset = "asset";
export const ModuleAssetType = "assetType";
export const ModuleAssetCategory = "assetCategory";
export const ModuleOrganizationUnit = "organizationUnit";
export const ModuleLayoutTemplate = "layoutTemplate";
export const ModuleOrganizationUnitType = "organizationUnitType";
export const ModuleProvider = "provider";
export const ModuleLocation = "location";
export const ModulePickList = "pickList";
export const ModuleJobPosition = "jobposition";
export const ModuleJobTitle = "jobtitle";
export const ModuleJobPositionAsset = "jobPositionAsset";
export const ModuleRole = "role";
export const ModuleEmployee = "employee";
export const ModuleEmployeeStatus = "employeestatus";
export const ModuleReport = "report";
export const ModuleUserSetting = "userSetting";
export const ModuleUser = "user";
export const ModuleCustomer = "customer";
export const ModuleTransaction = "transaction";
export const ModuleTransactions = "transactions";
export const ModuleDashboardTransactions = "dashboartransactions";
export const ModuleDBOption = "dboption";
export const ModueleAuditingLog = "auditinglog";
// export const ModuleTally = "tally";
export const ModuleAllocationReduceEmployee = "allocationReduceEmployee";
export const ModuleAllocationReduceDepartment = "allocationReduceDepartment";
export const ModuleAllocationReduceLocation = "allocationReduceLocation";
export const ModuleAudit = "audit";
export const ModuleUsageHistory = "usageHistory";
export const ModuleSchedule = "schedule";
export const ModuleProcess = "moduleprocess";
export const ModuleAccountObjectGroup = "moduleAccountObjectGroup";
export const ModuleTransfer = "transfer";
export const ModuleTemplate = "template";
export const ModuleAssetBalance = "assetBalance";
export const ModuleOption = "option";
export const ModuleTransactionControl = "transactioncontrol";
export const ModuleRefund = "refund";
export const ModuleUserSystem = "usersystem";
export const ModuleTransactionPaymentDashboard = "transactionpaymentdashboard";
export const ModulePaymentLink = "paymentlink";
export const ModuleRevenueManagement = "revenuemanagement";
export const ModuleCollectionPeriod = "collectionperiod";
export const ModuleCustomerContacts = "customercontacts";
export const ModuleTransactionControlReport = "transactionControlReport";
export const ModuleReportControl = "reportControl";
export const ModuleMerchantTransactionControlTransaction = "merchantTransactionControlTransaction";
export const ModuleEmbedPaymentDemoMarketing = "embedPaymentDemoMarketing";

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
  ModuleAuth,
  // ModuleCommon,
  // ModuleCompany,
  ModuleContext,
  // ModuleContactAdditional,
  ModuleDashboard,
  // ModuleDictionary,
  // ModuleLayout,
  // ModuleLicenseInfo,
  // ModuleAccessLog,
  // ModuleMisaOrder,
  ModuleNotifications,
  // ModuleOptions,
  // ModuleServiceTVAN,
  // ModuleTaxRegis,
  // ModuleTaxReturnRegisHistory,
  // ModuleTaxReturn,
  // ModuleTaxReturnSubmission,
  // ModuleTaxPaper,
  // ModuleTaxPayerInfo,
  ModuleAsset,
  ModuleAssetType,
  ModuleOrganizationUnit,
  ModuleAssetCategory,
  ModuleLayoutTemplate,
  ModuleOrganizationUnitType,
  ModuleProvider,
  ModuleLocation,
  ModulePickList,
  ModuleJobPosition,
  ModuleJobTitle,
  ModuleJobPositionAsset,
  ModuleRole,
  ModuleEmployee,
  ModuleEmployeeStatus,
  ModuleReport,
  ModuleUserSetting,
  ModuleUser,
  ModuleCustomer,
  ModuleDBOption,
  ModueleAuditingLog,
  ModuleAudit,
  // ModuleTally,
  ModuleAllocationReduceEmployee,
  ModuleAllocationReduceDepartment,
  ModuleAllocationReduceLocation,
  ModuleUsageHistory,
  ModuleSchedule,
  ModuleProcess,
  ModuleAccountObjectGroup,
  ModuleTransfer,
  ModuleTemplate,
  ModuleAssetBalance,
  ModuleOption,
  ModuleTransaction,
  ModuleTransactions,
  ModuleTransactionControl,
  ModuleRefund,
  ModuleUserSystem,
  ModuleTransactionPaymentDashboard,
  ModulePaymentLink,
  ModuleRevenueManagement,
  ModuleCollectionPeriod,
  ModuleCustomerContacts,
  ModuleTransactionControlReport,
  ModuleReportControl,
  ModuleMerchantTransactionControlTransaction,
  ModuleEmbedPaymentDemoMarketing,
];
